/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/pro-solid-svg-icons';

// Actions
import { updateEnrollment } from '../../../../../actions/enrollment';

// Components
import { LoaderButton } from '../../../../../common/components';

function ButtonText({ text, icon }) {
  return (
    <>
      <FontAwesomeIcon className="me-2" icon={icon} />
      {text}
    </>
  );
}

function Error({ text }) {
  return (
    <div className="text-danger">
      {text}
    </div>
  );
}

function Message({ text }) {
  return (
    <div className="fst-italic text-success">
      {text}
    </div>
  );
}

function Cancel({
  enrollment = {},
  // agent = {},
  id,
  className,
  style,
}) {
  const { quote_id } = enrollment;
  const [wasCancelled, setWasCancelled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const dispatch = useDispatch();
  useEffect(() => {
    const { cancelled } = enrollment;
    if (cancelled) {
      setWasCancelled(true);
      setMessage('The final submission of this enrollment to the carrier has already been cancelled.');
    }
  }, [enrollment]);

  function handleCancel() {
    setLoading(true);
    updateEnrollment({
      quote_id,
      cancelled: true,
    }).then((data = {}) => {
      const { cancelled } = data;
      if (cancelled) {
        setWasCancelled(true);
        setMessage('The final submission of this enrollment to the carrier has been cancelled.');
        setError('');
        // Make sure to update the store so the parent index/Table's values are updated too.
        dispatch({ type: 'SET_ENROLLMENT', payload: data });
      } else {
        setError('There was a problem cancelling this enrollment.');
        setMessage('');
      }
    }).catch((err = {}) => {
      const { message: errMessage } = err;
      console.error(errMessage);
      setError('There was a problem cancelling this enrollment.');
      setMessage('');
    }).finally(() => {
      setLoading(false);
    });
  }

  return (
    <div
      className={`d-flex flex-column d-print-none w-50 m-3 mt-1 pb-3 ${className}`}
      id={id}
      style={style}
    >
      <div className="fw-bold fs-4 m-1">Cancel Enrollment</div>
      <div className="m-1">
        Are you sure you wish to cancel the final submission of this enrollment to the carrier?
      </div>
      <div className="m-1">
        This action cannot be undone.
      </div>
      <div className="d-flex w-75 mt-3 mb-3">
        <LoaderButton
          className="btn btn-danger w-50 me-2 me-2 fw-bold text-white"
          loading={loading}
          text={<ButtonText text="Cancel" icon={faBan} />}
          loadingText={<ButtonText text="Canceling.." icon={faBan} />}
          onClick={handleCancel}
          disabled={wasCancelled}
        />
      </div>
      <Message text={message} />
      <Error text={error} />
    </div>
  );
}
export default Cancel;
